import Typography from '@mui/material/Typography'
import { DescriptionQuestion } from 'pages/Survey/types'
import { fontFamilies } from 'theme/styles.utils'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const SurveyDescription = ({ question }: { question: DescriptionQuestion }) => {
  const translatedTitle = useGetObjectTranslation(question.translation, 'title')
  return (
    <Typography variant="body1" align="left" fontFamily={fontFamilies.default}>
      {translatedTitle}
    </Typography>
  )
}
